import React from 'react';

function IconStar(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.0005 19.6453L5.9775 23.2883C5.76337 23.4345 5.50871 23.5097 5.2495 23.5033C5.0174 23.4962 4.79502 23.4085 4.6205 23.2553C4.44235 23.121 4.30013 22.9448 4.2065 22.7423C4.10503 22.507 4.08738 22.244 4.1565 21.9973L5.7465 15.1043L0.418504 10.4393C0.227494 10.2965 0.0926555 10.0913 0.0375041 9.85929C-0.0177325 9.63552 -0.0118616 9.40102 0.0545039 9.18029C0.121523 8.95836 0.254391 8.76202 0.435504 8.61729C0.628613 8.46089 0.865517 8.36829 1.1135 8.35229L8.1615 7.75229L10.8745 1.22829C10.9723 0.999866 11.1405 0.808599 11.3545 0.682294C11.5487 0.563096 11.7721 0.5 12 0.5C12.2279 0.5 12.4513 0.563096 12.6455 0.682294C12.8595 0.808599 13.0277 0.999866 13.1255 1.22829L15.8725 7.75229L22.8875 8.35229C23.1355 8.36829 23.3724 8.46089 23.5655 8.61729C23.7466 8.76202 23.8795 8.95836 23.9465 9.18029C24.0129 9.40102 24.0187 9.63552 23.9635 9.85929C23.9084 10.0913 23.7735 10.2965 23.5825 10.4393L18.2545 15.1043L19.8425 21.9923C19.9116 22.239 19.894 22.502 19.7925 22.7373C19.6989 22.9398 19.5567 23.116 19.3785 23.2503C19.204 23.4035 18.9816 23.4912 18.7495 23.4983C18.5002 23.5075 18.2551 23.4317 18.0545 23.2833L12.0005 19.6453Z" />
    </svg>
  );
}

export default IconStar;
